'use strict';

(function(){

    function getFieldError(error, field){
        if (!error || !error.incorrectFields) return undefined;
        var entry = error.incorrectFields.filter(function(entry){ return entry.field === field; });
        if (entry.length === 0) return undefined;
        return entry[0];
    }

    /*
    This defines an "enum" with the error codes sent by uwa
     */
    customerZone.value('errorCode', {
        INVALID_RECAPTCHA_RESPONSE: 'invalid_recaptcha_response',
        INVALID_GRANT: 'invalid_grant',
        INVALID_CREDENTIALS: 'invalid_credentials',
        INVALID_PHONE_VERIFICATION_CODE: 'invalid_phone_verification_code',
        INVALID_RESET_CODE: 'invalid_token',
        EMAIL_ADDRESS_ALREADY_IN_USE: 'email_already_in_use',
        ICCID_ALREADY_IN_USE: 'iccid_already_in_use',
        PASSWORD_TOO_COMMON: 'password_too_common',
        PASSWORD_ENTIRELY_NUMERIC: 'password_entirely_numeric',
        PASSWORD_TOO_SIMILAR: 'password_too_similar',
        PASSWORD_SIMILAR_TO_DETAILS: 'password_too_similar_to_personal_details',
        LOGIN_BY_EMAIL_IMPOSSIBLE: 'login_by_email_impossible',
        RESET_BY_EMAIL_IMPOSSIBLE: 'invalid_user',
        MNP_NUMBER_ALREADY_KNOWN: 'invalid_mnp_msisdn_in_use',
        UNKNOWN_USER: 'unknown_user',
        INVALID_FIELDS: 'invalid_fields',
        INVALID_VALUE: 'invalid_value',
        INVALID_IMEI: 'invalid_imei',
        NOT_PAYABLE: 'not_payable',
        UNKNOWN_SIM: 'sim_not_found',
        ALREADY_ACTIVATING: 'already_activating',
        ALREADY_ACTIVE: 'already_active',
        ACTION_NOT_AUTHORIZED: 'action_not_authorized',
        USER_IN_DUNNING: 'action_not_authorized_due_to_dunning',
        PACKAGE_ALREADY_ACTIVE: 'package_already_active',
        HTTP_CONNECTION_ERROR: 'connection_error__probably_timeout',
        SENT_TO_LOGIN: 'auth_required__user_redirected',
        REQUEST_THROTTLED: 'request_throttled',
        CLIENT_ERROR: 'client_error',
        SERVER_ERROR: 'technical_error',
        PAYMENT_CANCELLED: 'payment_cancelled',
        PAYMENT_REQUIRES_REVIEW: 'payment_cancelled',
        POLL_TIMEOUT: 'poll_timeout',
        POLL_CANCELLED: 'poll_cancelled',
        MANDATE_UNSETTABLE: 'mandate_cannot_be_set_invalid_values',
        MANDATE_INFO_MISSMATCH: 'debtor_bic_iban_mismatch',
        SWAP_ALREADY_RUNNING: 'swap_already_running',
        OTHER_PENDING_PROCESS: 'other_pending_language_change',
        SUBSCRIPTION_DEACTIVATED: 'subscription_deactivated',
        BAD_GATEWAY: 'invalid_response_from_upstream_server',
        WRONG_STATE: 'wrong_state',
        SECOND_MIGRATION_WITHIN_30_MINUTES: 'already_switched_within_short_timeframe',
        SWITCHING_PLANS_TOO_FREQUENTLY: 'switching_plans_too_frequently',

        /**
         * Check if a received error contains a given code
         */
        is: function(error, code, field) {
            if (error === code) return true;
            if (field){
                var fieldError = getFieldError(error, field);
                if (!fieldError) return false;
                for (var i=0; i < fieldError.errors.length; i++){
                    if (fieldError.errors[i].code === code) return true;
                }
                return false;
            }
            else
                return error && error.code && error.code.indexOf && error.code.indexOf(code) >= 0;
        },

        /**
         * Check if there is any error on the given field
         */
        on: function(error, field) {
            return !!getFieldError(error, field);
        },

        /**
         * Create a standard error format with the given code
         * @param code errorCode of the error to create
         * @param message (optional) message to add to the error
         * @param extraFields (optional) an object containing extra fields to add to the error
         */
        wrap: function(code, message, extraFields) {
            var result = {code: [code]};
            if (message)
                result.message = message;
            for (var fieldName in (extraFields || {}))
                result[fieldName] = extraFields[fieldName];
            return result;
        },

        /**
         * Create a standard error format with the given code for a field
         */
        wrapField: function(field, code) {
            return {
                code: [this.INVALID_FIELDS],
                incorrectFields: [
                    {field: field, errors: [{code: code}]}
                ]
            };
        }
    });
}());
